var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VSplideSlide',[_c('div',{staticClass:"atom-image-slider slide"},[_c('div',{staticClass:"image-relative"},[_c('div',{staticClass:"background-image",style:({
          'background-image': `url(${_vm.resourceUrl(_vm.sliderImage.image)})`,
          'background-size': _vm.backgroundSize
        })})]),_vm._v(" "),(_vm.sliderImage.description)?_c('div',{staticClass:"description"},[_vm._v("\n      "+_vm._s(_vm.sliderImage.description)+"\n    ")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }